import React, { Component } from 'react';
import _ from 'lodash';
import { Route } from 'react-router-dom';
import PriceSummaryExpanded from './PriceSummaryExpanded';
import PriceSummaryBar from './PriceSummaryBar';
import AccessoriesPrice from '../accessoriesPrice/AccessoriesPrice';
import AttributesNav from './AttributesNav';
import BreakpointMatch from '../../common/mediaQuery/BreakpointMatch';
import ScrollThreshold from './ScrollThreshold';
import { withModelInfo } from '../../common/ModelInfoContext';

class PriceSummary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isExpanded: false
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      this.setState({
        isExpanded: false
      });
    }
  }

  toggleExpanded = () => {
    if (this.props.modelInfo.enableNotifications) {
      this.setState({
        isExpanded: !this.state.isExpanded
      });
    }
  };

  render() {
    const {
      modelInfo,
      config,
      pricing,
      interiorIndex,
      exteriorIndex,
      images,
      switchThumbnail,
      attributes
    } = this.props;
    const { isExpanded } = this.state;

    const {
      year,
      country,
      title: bodyStyle,
      enableNotifications,
      isFamilyFirstUS
    } = modelInfo;
    const bodyTypeDescription = _.get(config, 'bodyType.formattedConfig', '');
    const trimName = _.get(config, 'style.trimName', '');
    const driveType = _.get(config, 'driveType.id', '');
    const eventName = _.get(config, 'style.vehicleInfo.promoEventName');
    const eligibleForInvoicePrice = config.eligibleForInvoicePrice;

    return (
      <BreakpointMatch
        breakpoint="large"
        render={isLarge => {
          return (
            <ScrollThreshold
              threshold={() => {
                const carousel = document.querySelector('.carousel');
                const pricing = document.querySelector('.price-summary-bar');
                return (
                  carousel &&
                  pricing &&
                  carousel.getBoundingClientRect().bottom < pricing.clientHeight
                );
              }}>
              {isImageVisible => {
                const displayThumbnail =
                  (isExpanded && !isLarge) || isImageVisible;

                return (
                  <div>
                    <PriceSummaryBar
                      isExpanded={isExpanded}
                      pricing={pricing}
                      year={year}
                      bodyStyle={bodyStyle}
                      driveType={driveType}
                      config={bodyTypeDescription}
                      trim={trimName}
                      onToggleExpanded={this.toggleExpanded}
                      images={images}
                      interiorIndex={interiorIndex}
                      exteriorIndex={exteriorIndex}
                      switchThumbnail={switchThumbnail}
                      displayThumbnail={displayThumbnail}
                      disableExpansion={!enableNotifications}
                    />
                    {isExpanded && (
                      <PriceSummaryExpanded
                        displayThumbnail={displayThumbnail}
                        driveType={driveType}
                        trim={trimName}
                        config={bodyTypeDescription}
                        year={year}
                        pricing={pricing}
                        eligibleForInvoicePrice={eligibleForInvoicePrice}
                        eventName={eventName}
                        country={country}
                        isFamilyFirstUS={isFamilyFirstUS}
                        onClose={this.toggleExpanded}
                      />
                    )}
                    {!isExpanded &&
                      !isLarge && (
                        <AccessoriesPrice value={pricing.accessoriesTotal} />
                      )}
                    {!isLarge &&
                      attributes.length > 0 && (
                        <Route
                          path="/config"
                          render={() => (
                            <AttributesNav
                              attributes={attributes}
                              selections={config.selections}
                            />
                          )}
                        />
                      )}
                  </div>
                );
              }}
            </ScrollThreshold>
          );
        }}
      />
    );
  }
}
export default withModelInfo(PriceSummary);
